var fn_update_browser = function () {


        if (($('html').hasClass('ie9')))
        {
            var updateMessage = "<div style=\"position: relative;z-index: 1100;margin: 0 auto;text-align: center;\" class=\"update-browser\"><p style=\"display: inline-block; border: 0.4rem solid red; padding: 4rem 2rem; background: white; font-size: 2.2rem; font-weight: 700;\">La version de votre navigateur est trop ancienne pour accéder à ce contenu et cause des problèmes d'affichage. Nous vous invitons à le mettre à jour.</p></div>";
            $('body').prepend(updateMessage);
        }

}